import { router } from '../app/router';

export function renderNotFoundPage(container: HTMLElement): void {
  container.innerHTML = `
    <main class="section pt-nav">
      <div class="container max-w-md">
        <div class="empty-state">
          <i class="fa-solid fa-map-signs"></i>
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <div class="flex items-center justify-center gap-4 mt-6">
            <button class="btn btn-primary" id="notFoundHomeBtn">
              <i class="fa-solid fa-house"></i> Go Home
            </button>
            <button class="btn btn-secondary" id="notFoundBackBtn">
              <i class="fa-solid fa-arrow-left"></i> Go Back
            </button>
          </div>
        </div>
      </div>
    </main>
  `;

  document.getElementById('notFoundHomeBtn')?.addEventListener('click', () => router.navigate('/'));
  document.getElementById('notFoundBackBtn')?.addEventListener('click', () => window.history.back());
}